import React, {Component} from 'react';
import {Economentry} from '../entries'
import styles from './style.css';


export default class Econom extends Component {
    render() {
        return (
            <div className={[this.props.className, styles.App].join(' ')}>
                <Economentry/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Econom/index.jsx